import { render, staticRenderFns } from "./BrowseIcon.vue?vue&type=template&id=0deaae6d&"
import script from "./BrowseIcon.vue?vue&type=script&lang=js&"
export * from "./BrowseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports